// 22 fields
export var dateFields = function () { return [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; };
//# sourceMappingURL=fields.js.map